const global = {
  init() {
    jQuery('body').on('added_to_cart', () => {
      global.getProductsCount();
    });

    jQuery('body').on('removed_from_cart', () => {
      global.getProductsCount();
    });

    jQuery('body').on('wc_cart_emptied', () => {
      global.getProductsCount();
    });

    jQuery('body').on('updated_cart_totals', () => {
      global.getProductsCount();
    });
  },
  getProductsCount() {
    const cartCounts = document.querySelectorAll('#cart-items-count');

    if (!cartCounts) return;

    const params = new URLSearchParams({
      action: 'get_products_count',
    });

    fetch(`${balsamData.ajaxurl}?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': balsamData.nonce,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.success) {
          return;
        }

        cartCounts.forEach((cartCount) => {
          cartCount.textContent = data.data.count;
        });
      })
      .catch((error) => console.error('Fetch error:', error));
  },
};

export default global;
